const delay =  300;
export default delay;